import moment from "moment";

import local from "../data/candidates";
import http from "@seims/shared/src/services/HttpService";

var endpoint = `/candidate/`;

const getDemographics = async (id) => {
  const response = await http.get(`${endpoint}demographics/${id}`);
  return response;
};

const getQualifications = async (id) => {
  const response = await http.get(`${endpoint}qualifications/${id}`);
  return response;
};

const getCandidates = async () => {
  const response = await http.get(`${endpoint}list/details`);
  return response;
};

const getCandidateById = async (userId, intake) => {
  const response = await http.get(`${endpoint}view/${userId}?intake=${intake}`);
  return response;
};

const getFile = async (id, userId) => {
  const response = await http.get(
    `${endpoint}supporting/documents/${id}/${userId}`,
    { responseType: "arraybuffer" }
  );
  return response;
};

const updatePlacementStatus = async (placement) => {
  const { placedProvince, effectiveDate, userId, intake } = placement;
  const placementStartDate = new Date(effectiveDate).toISOString();

  const response = await http.put(
    `${endpoint}placement/placed/${userId}?provinceId=${placedProvince.key}&date=${placementStartDate}&intake=${intake}`
  );
  return response;
};

const updateExitDirection = async (exit) => {
  const { exitDirection, effectiveDate, userId, intake } = exit;
  const placementEndDate = new Date(effectiveDate).toISOString();

  const response = await http.put(
    `${endpoint}exitdirection/update/${userId}?exitDirection=${exitDirection}&statusUpdateDate=${placementEndDate}&intake=${intake}`
  );
  return response;
};

const sendHost = async (userId, hostEmail, intake) => {
  const response = await http.post(
    `${endpoint}placement/${userId}?hostEmail=${hostEmail}&intake=${intake}`
  );
  return response;
};

const getCandidatesByStatus = async ({
  statusKey,
  first,
  max,
  text = null,
  intake,
}) => {
  var urlPath = `${endpoint}list/details/${statusKey}?offset=${first}&limit=${max}&intake=${intake}`;

  if (text !== null && text !== undefined && text !== "") {
    urlPath += `&searchText=${text}`;
  }
  const response = await http.get(urlPath);
  return response;
};

const candidateWithdraw = async (candidateUserId, intake) => {
  const response = await http.post(
    `${endpoint}withdraw/${candidateUserId}?$&intake=${intake}`
  );
  return response;
};

const getNYSIntake = async ({ first, max }) => {
  const response = await http.get(
    `${endpoint}intakes?offset=${first}&limit=${max}`
  );
  return response;
};

const rejectCandidate = async (userId, intake, reason) => {
  const response = await http.put(
    `${endpoint}reject/${userId}?intake=${intake}&reason=${reason}`
  );
  return response;
};

export default {
  getDemographics,
  getQualifications,
  getCandidates,
  getCandidateById,
  getFile,
  updatePlacementStatus,
  updateExitDirection,
  sendHost,
  getCandidatesByStatus,
  candidateWithdraw,
  getNYSIntake,
  rejectCandidate,
};
